export default __webpack_public_path__ + "static/media/bs4.2.c68b7cbe.png";